export const _STATUS_CODE = {
    ONLINE: '0',
    OFFLINE: '1',
    OUT: '2',
    BUSINESS: '3'
}

export const _PROFILE_STATUS_CODE = [
   'online',
   'offline',
   'out',
   'business',
]

